import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInvoiceDownloadPdf = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 29,
	viewBox: "0 0 22 29",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2.53846 1C1.69231 1 1 1.72727 1 2.61616V26.0505C1 26.9394 1.69231 27.6667 2.53846 27.6667H19.4615C20.3077 27.6667 21 26.9394 21 26.0505V23.2222V16.7576V10.2929V7.04807C21 6.27799 20.7039 5.5374 20.1729 4.97962L17.2714 1.93156C16.7051 1.3367 15.9198 1 15.0985 1H2.53846Z",
			fill: "#EE2B2B",
			fillOpacity: .5,
			stroke: "#EE2B2B",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.49822 12.4004C5.99422 12.4004 6.42355 12.4831 6.78622 12.6484C7.15422 12.8137 7.43689 13.0484 7.63422 13.3524C7.83155 13.6564 7.93022 14.0164 7.93022 14.4324C7.93022 14.8431 7.83155 15.2031 7.63422 15.5124C7.43689 15.8164 7.15422 16.0511 6.78622 16.2164C6.42355 16.3764 5.99422 16.4564 5.49822 16.4564H4.37022V18.0004H3.07422V12.4004H5.49822ZM5.42622 15.4004C5.81555 15.4004 6.11155 15.3177 6.31422 15.1524C6.51689 14.9817 6.61822 14.7417 6.61822 14.4324C6.61822 14.1177 6.51689 13.8777 6.31422 13.7124C6.11155 13.5417 5.81555 13.4564 5.42622 13.4564H4.37022V15.4004H5.42622Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.69547 12.4004H11.2395C11.8475 12.4004 12.3835 12.5177 12.8475 12.7524C13.3168 12.9817 13.6795 13.3071 13.9355 13.7284C14.1968 14.1497 14.3275 14.6404 14.3275 15.2004C14.3275 15.7604 14.1968 16.2511 13.9355 16.6724C13.6795 17.0937 13.3168 17.4217 12.8475 17.6564C12.3835 17.8857 11.8475 18.0004 11.2395 18.0004H8.69547V12.4004ZM11.1755 16.9364C11.7355 16.9364 12.1808 16.7817 12.5115 16.4724C12.8475 16.1577 13.0155 15.7337 13.0155 15.2004C13.0155 14.6671 12.8475 14.2457 12.5115 13.9364C12.1808 13.6217 11.7355 13.4644 11.1755 13.4644H9.99147V16.9364H11.1755Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.4408 13.4404V14.9204H19.0328V15.9604H16.4408V18.0004H15.1448V12.4004H19.3768V13.4404H16.4408Z",
			fill: "white"
		})
	]
});
export default SvgInvoiceDownloadPdf;
